export default __webpack_public_path__ + "static/diamond_w.c19dd1e02c56a7d6c8a5f36f15f598c4.png";